export const EXPANSIONS_DB_KEY = 'expansions-1.8'
